/**
 *  AenaPointsCategories script file
**/

import { AenaTerminalsFilter } from './aena-terminals-filter'
import { AenaTerminalsCategories } from './aena-terminals-categories'
import setLocation from '@/mixins/setLocation'
import { GETTERS, MUTATIONS } from '@/store'
import { mapGetters, mapMutations } from 'vuex'
import getRoutePoint from '@/mixins/getRoutePoint'
import { normalizeLowerCase } from '@/utils/matchString'
import setDeviceWidthClass from '@/mixins/setDeviceWidthClass'

export default {
  name: 'app-aenaPointsCategories',
  mixins: [setLocation, getRoutePoint, setDeviceWidthClass],
  components: {
    AenaTerminalsFilter,
    AenaTerminalsCategories
  },
  props: {
    points: {
      type: Array,
      required: true
    },
    airport: {
      type: Object,
      required: true
    },
    filters: {
      type: Array,
      required: true
    },
    activeFilters: {
      type: Object,
      required: true
    },
    category: {
      type: Object
    },
    categories: {
      type: Array,
      required: true
    },
    search: {
      type: Boolean,
      default: false
    },
    headerHeight: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      grouped: new Map(),
      goToTopVisible: false
    }
  },
  created () {
    this.setLocation(this.points)
  },
  mounted () {
    // NOTE: accessibility trick
    this.$refs.scrollContent.addEventListener('mouseover', () => {
      this.$refs.scrollContent.style.visibility = 'visible'
    }, false)
    this.$refs.scrollContent.addEventListener('mouseout', () => {
      this.$refs.scrollContent.style.visibility = 'hidden'
    }, false)
  },
  computed: {
    ...mapGetters({
      isMobile: GETTERS.GET_IS_MOBILE,
      isRouteMode: GETTERS.IS_ROUTE_MODE,
      airportID: GETTERS.GET_AIRPORT_ID,
      filtering: GETTERS.GET_FILTERING
    }),
    showCategories () {
      return this.category || (this.categories && this.categories.length)
    },
    pois () {
      const map = new Map()

      this.points.forEach(point => {
        const key = point.properties.attrs.pat_nombre + point.properties.location.name + point.properties.level
        const el = map.get(key)
        if (el) {
          const g = this.grouped.get(el.properties.id)
          g.push(point)

          this.grouped.set(el.properties.id, g)
          el.total++
        } else {
          this.grouped.set(point.properties.id, [point])
          point.total = 1
          map.set(key, point)
        }
      })

      return [...map.values()]
    }
  },
  methods: {
    ...mapMutations([
      MUTATIONS.SAVE_FILTERING
    ]),
    setFilter (filter) {
      this.$emit('onFilter', filter)
    },
    setCategory (categories) {
      this.$emit('onCategory', categories)
      this.updateScrollbar()
    },
    selectPoint (point) {
      if (!this.isRouteMode) {
        this.$emit('onSelect', { component: 'aena-point-detail', pointDetail: point.properties, pointGrouped: this.grouped.get(point.properties.id) })
      } else {
        const p = this.moreClose(this.grouped.get(point.properties.id))
        this.$emit('onSelect', { component: 'aena-route-poi', pointDetail: p })
      }

      const label = `${point.properties.location.name}. planta ${point.properties.levelName}. ${this.$t(point.properties.attrs.pat_nombre)}`
      const tag = {
        'eventCategory': 'buscador',
        'eventAction': 'buscar',
        'eventLabel': `${normalizeLowerCase(label)}`,
        'language': this.$i18n.locale,
        'airportID': this.airportID
      }
      window.digitalChange('event', tag)
    },
    getBuildingName (id) {
      return `${this.$t('IN')} ${(this.filters.find(filter => filter.id === id) || {}).name}`
    },
    getCategoryName (id) {
      return `${(this.categories.find(category => category.id === id) || {}).name}`
    },
    updateScrollbar () {
      setTimeout(() => {
        this.$refs.scrollbar.update()
      }, 360)
    },
    onScroll (event) {
      if (event.y >= 60) {
        this.goToTopVisible = true
      } else {
        this.goToTopVisible = false
      }
    },
    goToTop () {
      this.$refs.scrollbar.scrollTo(0, 0)
    },
    goBack (value = 'aena-points-list') {
      this.$emit('onSelect', { component: value, search: undefined })
    },
    toggleFiltering () {
      this[MUTATIONS.SAVE_FILTERING](!this.filtering)
    }
  },
  watch: {
    points (value) {
      this.setLocation(value)
    }
  }
}
